// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageImageProcess_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 8H9.58576L7.75735 6.1716L9.17156 4.75738L11 6.58582L11 0H13L13 6.58575L14.8285 4.75729L16.2427 6.1715L14.4142 8L21 8V10L14.4142 10L16.2426 11.8284L14.8284 13.2427L13 11.4142V24H11L11 11.4142L9.17161 13.2426L7.7574 11.8284L9.58575 10H3V8Z" class="svg-bg"/>
  <path d="M6.34314 4.75738 3.51471 1.92896 4.92892.514742 7.75735 3.34317 6.34314 4.75738ZM19.0711 17.4853 20.4853 16.0711 17.6568 13.2427 16.2426 14.6569 19.0711 17.4853ZM19.0711.514648 16.2427 3.34308 17.6569 4.75729 20.4853 1.92886 19.0711.514648ZM3.51476 16.071 6.34318 13.2426 7.7574 14.6568 4.92897 17.4852 3.51476 16.071Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageImageProcess is a generated icon component.
 */
let IconImageImageProcess = IconImageImageProcess_1 = class IconImageImageProcess extends IconBaseElement {
    render() {
        return html `${IconImageImageProcess_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageImageProcess.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconImageImageProcess = IconImageImageProcess_1 = __decorate([
    customElement('zui-icon-image-image-process')
], IconImageImageProcess);
export { IconImageImageProcess };
